const largeProjects = [
    {
        id: 1,
        title: "Enable the support of Wireguard in NeST",
        hours: 350,
        brief: "Wireguard is a L3 VPN that got integrated into the mainline of the Linux kernel since version 5.6, released in March 2020. The official website of Wireguard states that it can be easily integrated with network namespaces and provides examples to do this. Network Stack Tester (NeST) is a python wrapper built around network namespaces to simplify the efforts needed to perform network emulations. Recently, APIs for L2 VPN, called OpenVPN, have been developed for NeST and the respective merge request is under review. The main idea of this project is to build a similar kind of APIs to enable the support of Wireguard in NeST. The NeST user must leverage the underlying Wireguard feature of the Linux kernel with easy-to-use APIs and perform network emulations using Wireguard and NeST. The merge request for OpenVPN can be used as a reference to build APIs for Wireguard in NeST.",
        requiredExperience: "Python",
        bonusExperience: "Knowledge of Wireguard and NeST is a plus",
        difficulty: "Moderate",
        reading: [
            { title: "NeST", link: "https://gitlab.com/nitk-nest/nest" },
            {
                title: "Wireguard integration with network namespaces",
                link: "https://www.wireguard.com/netns/",
            },
            { title: "wg-netns", link: "https://github.com/dadevel/wg-netns" },
            {
                title: "OpenVPN Merge Request in NeST",
                link: "https://gitlab.com/nitk-nest/nest/-/merge_requests/302",
            },
        ],
    },
    {
        id: 2,
        title: "Redesign the routing module in Network Stack Tester (NeST)",
        hours: 350,
        brief: "The routing module in Network Stack Tester (NeST) has been under active development in the recent past, and now supports both static and dynamic routing. The routing frameworks such as Quagga, Free Range Routing (FRR) and Bird Internet Routing Daemon (BIRD) have been integrated in NeST. These frameworks allow the NeST users to emulate any routing protocol supported in these frameworks. However, the initial design of the 'routing helper' in NeST did not consider the fact that several routing frameworks will be integrated into NeST. Hence, there is a scope of improving the design and generalizing it so that the integration of routing frameworks is simplified and extensible for future use. Thus, the key idea of this project is to redesign the routing module in NeST and test its functionality.",
        requiredExperience: "Python",
        bonusExperience: "Knowledge of NeST is a plus",
        difficulty: "Moderate",
        reading: [
            { title: "NeST website", link: "https://nest.l4.nitk.ac.in/" },
            {
                title: "NeST paper",
                link: "https://dl.acm.org/doi/abs/10.1145/3404868.3406670",
            },
            {
                title: "GitLab issue for this work",
                link: "https://gitlab.com/nitk-nest/nest/-/issues/239",
            },
        ],
    },
    {
        id: 3,
        title: "Web-based Topology Visualizer and Dashboard for NeST",
        hours: 350,
        brief: "Currently, NeST users must write Python code to define topologies without any visual feedback until runtime. They rely on terminal output to monitor experiments and manually analyze JSON dump files post-experiment. This project aims to build a web-based dashboard for NeST that provides: (i) an interactive topology builder with drag-and-drop interface to create network topologies visually, (ii) real-time visualization of network metrics (throughput, latency, packet loss, queue depth) during experiment execution (iii) a code generator that exports the visual topology to executable NeST Python code, and (iv) a results viewer for post-experiment analysis with interactive charts. This tool will dramatically improve the user experience for students learning networking concepts, researchers prototyping experiment topologies, and instructors demonstrating network behavior in classrooms.",
        mentor: "Shanthanu S. Rai",
        requiredExperience: "Python, HTML, CSS, JS",
        bonusExperience: "Websockets, Streams, React/Vue.js",
        difficulty: "Moderate",
        reading: [
            { title: "NeST website", link: "https://nest.l4.nitk.ac.in/" },
            {
                title: "NeST paper",
                link: "https://dl.acm.org/doi/abs/10.1145/3404868.3406670",
            },
        ],
    },
];

export default largeProjects;
